// Shells mint a null alias (see deriveShellRoutes) so the alias stays a genuine user override and
// the name can follow the resource when a route is repointed or a resource renamed.
//
// Two shapes because call sites disagree on the fallback: some render a bare route number, some
// prefix it with "Route".

export const routeName = (route) => route?.route_alias || route?.resource?.name || null;

export const routeDisplayName = (route) => {
    const name = routeName(route);
    if (name) {
        return name;
    }

    return isFinite(route?.route_number) && route?.route_number !== null ? `Route ${route.route_number}` : '--';
};
